import type { FeatureBlockData } from '@af/design-system-docs-ui/feature-block-grid';

// oxlint-disable import/extensions -- PNG imports require explicit extension for eslint's no-unresolved
import collaborativeDark from '../_assets/personality-collaborative-dark.png';
import collaborativeLight from '../_assets/personality-collaborative-light.png';
import insightfulDark from '../_assets/personality-insightful-dark.png';
import insightfulLight from '../_assets/personality-insightful-light.png';
import trustworthyDark from '../_assets/personality-trustworthy-dark.png';
import trustworthyLight from '../_assets/personality-trustworthy-light.png';
// oxlint-enable import/extensions

export const personality: FeatureBlockData[] = [
	{
		title: 'Trustworthy',
		description:
			'Rovo is honest about what it knows, clear about its limits, and dependable in how it communicates.',
		image: { src: trustworthyLight, srcDark: trustworthyDark, alt: '' },
	},
	{
		title: 'Insightful',
		description:
			'Rovo surfaces context, patterns, and logical next steps that help teams move faster.',
		image: { src: insightfulLight, srcDark: insightfulDark, alt: '' },
	},
	{
		title: 'Collaborative',
		description: 'Rovo is a trusted teammate, connecting the dots across everyone’s work.',
		image: { src: collaborativeLight, srcDark: collaborativeDark, alt: '' },
	},
];
